(function () {
  'use strict';

  if (window.cartRewardsProgressInitialized) {
    return;
  }

  window.cartRewardsProgressInitialized = true;

  const ROOT_SELECTOR = '[data-cart-rewards-progress]';
  const MYKONOS_VIBES_BAG_TITLE = 'MYKONOS VIBES BAG';

  const CART_EVENTS = [
    'cart:updated',
    'cart:change',
    'cart:refresh',
    'ajaxCart:updated',
    'cart-drawer:updated',
    'cart:quantity:update',
    'cartUpdate'
  ];

  const fetchTimers = [];
  let updateGeneration = 0;
  let promotionalGiftCleanupInProgress = false;

  function toNumber(value) {
    const number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function formatMoney(cents, root) {
    const symbol = root.dataset.moneySymbol || '\u20AA';
    const amount = Math.max(0, Math.ceil(toNumber(cents) / 100));

    return `${symbol}${amount.toLocaleString('he-IL')}`;
  }

  function replaceAmount(template, amount) {
    return String(template || '').replace(/\[amount\]/g, amount);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatRewardText(value) {
    const breakToken = '___CART_REWARDS_BR___';

    return String(value || '')
      .trim()
      .replace(/&lt;br\s*\/?&gt;/gi, breakToken)
      .replace(/<br\s*\/?>/gi, breakToken)
      .replace(/\[br\]/gi, breakToken)
      .replace(/\n/g, breakToken)
      .split(breakToken)
      .map(function (part) {
        return escapeHtml(part);
      })
      .join('<br>');
  }

  function calculateSegmentProgress(totalPrice, startThreshold, endThreshold) {
    if (endThreshold <= startThreshold || totalPrice <= startThreshold) {
      return 0;
    }

    if (totalPrice >= endThreshold) {
      return 100;
    }

    return Math.max(
      0,
      Math.min(100, ((totalPrice - startThreshold) / (endThreshold - startThreshold)) * 100)
    );
  }

  function updateSegmentProgress(root, shippingDiscountProgress, discountBagProgress) {
    root.style.setProperty(
      '--cart-rewards-shipping-discount-progress',
      `${shippingDiscountProgress}%`
    );
    root.style.setProperty('--cart-rewards-discount-bag-progress', `${discountBagProgress}%`);
  }

  function setStageState(root, stageName, unlocked, current) {
    const stage = root.querySelector(`[data-reward-stage="${stageName}"]`);

    if (!stage) {
      return;
    }

    stage.classList.toggle('is-unlocked', unlocked);
    stage.classList.toggle('is-current', current);
  }

  function setText(root, name, text) {
    const element = root.querySelector(`[data-reward-text="${name}"]`);

    if (!element) {
      return;
    }

    const html = formatRewardText(text);

    if (element.innerHTML !== html) {
      element.innerHTML = html;
    }
  }

  function updateRoot(root, cartData) {
    if (!root) {
      return;
    }

    const totalPrice = cartData ? toNumber(cartData.total_price) : toNumber(root.dataset.cartTotalPrice);
    const itemCount = cartData ? toNumber(cartData.item_count) : toNumber(root.dataset.cartItemCount);

    const shippingThreshold = toNumber(root.dataset.shippingThreshold);
    const discountThreshold = toNumber(root.dataset.discountThreshold);
    const bagThreshold = toNumber(root.dataset.bagThreshold);

    const shippingPendingText = root.dataset.shippingPendingText || '';
    const shippingUnlockedText = root.dataset.shippingUnlockedText || '';
    const discountPendingText = root.dataset.discountPendingText || '';
    const discountUnlockedText = root.dataset.discountUnlockedText || '';
    const bagPendingText = root.dataset.bagPendingText || '';
    const bagUnlockedText = root.dataset.bagUnlockedText || '';

    if (cartData) {
      root.dataset.cartTotalPrice = String(totalPrice);
      root.dataset.cartItemCount = String(itemCount);
    }

    if (itemCount <= 0) {
      root.hidden = true;
      return;
    }

    root.hidden = false;

    const shippingUnlocked = totalPrice >= shippingThreshold;
    const discountUnlocked = totalPrice >= discountThreshold;
    const bagUnlocked = totalPrice >= bagThreshold;

    const shippingCurrent = !shippingUnlocked;
    const discountCurrent = shippingUnlocked && !discountUnlocked;
    const bagCurrent = discountUnlocked && !bagUnlocked;

    updateSegmentProgress(
      root,
      calculateSegmentProgress(totalPrice, shippingThreshold, discountThreshold),
      calculateSegmentProgress(totalPrice, discountThreshold, bagThreshold)
    );

    setStageState(root, 'shipping', shippingUnlocked, shippingCurrent);
    setStageState(root, 'discount', discountUnlocked, discountCurrent);
    setStageState(root, 'bag', bagUnlocked, bagCurrent);

    setText(
      root,
      'shipping',
      shippingUnlocked
        ? shippingUnlockedText
        : replaceAmount(shippingPendingText, formatMoney(shippingThreshold - totalPrice, root))
    );

    setText(
      root,
      'discount',
      discountUnlocked
        ? discountUnlockedText
        : replaceAmount(discountPendingText, formatMoney(discountThreshold - totalPrice, root))
    );

    setText(
      root,
      'bag',
      bagUnlocked
        ? bagUnlockedText
        : replaceAmount(bagPendingText, formatMoney(bagThreshold - totalPrice, root))
    );
  }

  function updateAll(cartData) {
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      updateRoot(root, cartData);
    });
  }

  function normalizeTitle(value) {
    return String(value || '').trim().replace(/\s+/g, ' ').toLocaleLowerCase('he-IL');
  }

  function getPromotionalProductTitles() {
    const root = document.querySelector(ROOT_SELECTOR);
    const titles = [MYKONOS_VIBES_BAG_TITLE];

    if (root && root.dataset.sampleBagProductTitle) {
      titles.push(root.dataset.sampleBagProductTitle);
    }

    return new Set(titles.map(normalizeTitle).filter(Boolean));
  }

  function findPaidPromotionalDuplicate(cartData) {
    const promotionalProductTitles = getPromotionalProductTitles();

    if (!promotionalProductTitles.size || !cartData || !Array.isArray(cartData.items)) {
      return null;
    }

    const promotionalItems = cartData.items
      .map(function (item, index) {
        return { item: item, index: index };
      })
      .filter(function (entry) {
        return promotionalProductTitles.has(normalizeTitle(entry.item.product_title));
      });

    const freePromotionalItems = promotionalItems.filter(function (entry) {
      return toNumber(entry.item.original_line_price) > 0 &&
        toNumber(entry.item.final_line_price) === 0;
    });

    const paidPromotionalItemToReplace = promotionalItems.find(function (entry) {
      if (toNumber(entry.item.final_line_price) <= 0) {
        return false;
      }

      return freePromotionalItems.some(function (freeEntry) {
        return String(freeEntry.item.variant_id) === String(entry.item.variant_id) &&
          freeEntry.index < entry.index;
      });
    });

    return paidPromotionalItemToReplace ? paidPromotionalItemToReplace.item : null;
  }

  function renderUpdatedCart(cartData) {
    const cartDrawer = document.querySelector('cart-drawer');

    if (
      cartDrawer &&
      cartData &&
      cartData.sections &&
      typeof cartDrawer.renderContents === 'function'
    ) {
      cartDrawer.renderContents(cartData);
    }
  }

  function removePaidPromotionalDuplicate(cartData) {
    if (promotionalGiftCleanupInProgress) {
      return Promise.resolve(false);
    }

    const paidPromotionalItem = findPaidPromotionalDuplicate(cartData);

    if (!paidPromotionalItem || !paidPromotionalItem.key) {
      return Promise.resolve(false);
    }

    const shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    const changeUrl = window.routes && window.routes.cart_change_url
      ? window.routes.cart_change_url
      : `${shopRoot}cart/change.js`;
    const cartDrawerSection = document.querySelector('[cart-drawer-section]');
    const sectionId = cartDrawerSection ? cartDrawerSection.dataset.id : '';
    const requestBody = {
      id: paidPromotionalItem.key,
      quantity: 0,
      sections_url: window.location.pathname
    };

    if (sectionId) {
      requestBody.sections = [sectionId];
    }

    promotionalGiftCleanupInProgress = true;

    return fetch(changeUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Paid promotional gift removal failed');
        }

        return response.json();
      })
      .then(function (updatedCart) {
        updateAll(updatedCart);
        renderUpdatedCart(updatedCart);

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: updatedCart }
        }));

        return true;
      })
      .catch(function () {
        return false;
      })
      .finally(function () {
        promotionalGiftCleanupInProgress = false;
      });
  }

  function processCart(cartData) {
    updateAll(cartData);

    return removePaidPromotionalDuplicate(cartData);
  }

  function clearFetchTimers() {
    while (fetchTimers.length) {
      clearTimeout(fetchTimers.pop());
    }
  }

  function fetchCartAndUpdate(delay) {
    const generation = updateGeneration;
    const timeout = setTimeout(function () {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

      fetch(`${root}cart.js`, {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Cart request failed');
          }

          return response.json();
        })
        .then(function (cart) {
          if (generation !== updateGeneration) {
            return;
          }

          return processCart(cart);
        })
        .catch(function () {
          if (generation !== updateGeneration) {
            return;
          }

          updateAll();
        });
    }, delay || 600);

    fetchTimers.push(timeout);
  }

  function fetchCartAfterCartChange() {
    updateGeneration += 1;
    clearFetchTimers();

    fetchCartAndUpdate(500);
    fetchCartAndUpdate(1200);
    fetchCartAndUpdate(2500);
    fetchCartAndUpdate(4500);
  }

  function fetchCartAfterUserClick() {
    updateGeneration += 1;
    clearFetchTimers();

    fetchCartAndUpdate(700);
    fetchCartAndUpdate(1300);
  }

  function updateFromCart(cartData) {
    updateGeneration += 1;
    clearFetchTimers();
    processCart(cartData);
  }

  function initCartRewardsProgress() {
    updateAll();
    fetchCartAndUpdate(100);
    fetchCartAndUpdate(900);
    fetchCartAndUpdate(1800);

    CART_EVENTS.forEach(function (eventName) {
      document.addEventListener(eventName, fetchCartAfterCartChange);
      window.addEventListener(eventName, fetchCartAfterCartChange);
    });

    if (typeof subscribe === 'function') {
      subscribe('cart-update', fetchCartAfterCartChange);
    }

    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && typeof MutationObserver === 'function') {
      const cartObserver = new MutationObserver(function (mutations) {
        const cartContentsChanged = mutations.some(function (mutation) {
          return mutation.type === 'childList' &&
            (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0);
        });

        if (cartContentsChanged && !promotionalGiftCleanupInProgress) {
          fetchCartAfterCartChange();
        }
      });

      cartObserver.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
    }

    document.addEventListener('change', function (event) {
      const target = event.target;

      if (!(target instanceof Element)) {
        return;
      }

      if (target.matches('[name="updates[]"]') || target.matches('.ajax-quantity')) {
        fetchCartAfterUserClick();
      }
    });

    document.addEventListener('click', function (event) {
      const target = event.target;

      if (!(target instanceof Element)) {
        return;
      }

      if (
        target.closest('[button-plus]') ||
        target.closest('[button-minus]') ||
        target.closest('cart-remove-button') ||
        target.closest('[data-cart-remove]')
      ) {
        fetchCartAfterUserClick();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartRewardsProgress);
  } else {
    initCartRewardsProgress();
  }

  window.updateCartRewardsProgress = updateFromCart;
})();
